import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Alert, Card, Container, Spinner } from "react-bootstrap";

const normalizeApiRoot = (url) => {
  const value = String(url || "").trim().replace(/^['"]+|['";]+$/g, "").trim();
  if (!value) return "https://api.matters3.feradel.com";
  if (value.startsWith("/")) return value.replace(/\/+$/, "");
  if (/^https?:\/\//i.test(value)) return value.replace(/\/+$/, "");
  if (/^(localhost|127\.0\.0\.1|\[::1\])(?::|\/|$)/i.test(value)) return `http://${value}`.replace(/\/+$/, "");
  return `https://${value}`.replace(/\/+$/, "");
};

const publicApiRoot = () => {
  const stored = typeof localStorage !== "undefined" ? localStorage.getItem("api") : "";
  const root = normalizeApiRoot(stored);
  if (root.endsWith("/api/v1")) return root;
  if (root.endsWith("/api")) return `${root}/v1`;
  return `${root}/api/v1`;
};

const publicOptOutUrl = () => `${publicApiRoot()}/public/leads/campaigns/opt-out`;

const messageFromError = (error) =>
  error?.response?.data?.error?.message ||
  error?.response?.data?.message ||
  error?.message ||
  "The opt-out link could not be processed.";

const EmailOptOut = () => {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const token = params.get("token") || params.get("t") || "";
  const instance = params.get("i") || params.get("instance") || "";
  const preview = params.get("preview") === "1" || params.get("preview") === "true";
  const email = params.get("email") || "";
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Processing your opt-out request...");

  useEffect(() => {
    let active = true;

    const optOut = async () => {
      if (preview) {
        if (instance) localStorage.setItem("instance", instance);
        setStatus("success");
        setMessage(email
          ? `${email} has been opted out of CRM email campaigns.`
          : "You have been opted out of CRM email campaigns.");
        return;
      }

      if (!token || !instance) {
        setStatus("error");
        setMessage("This opt-out link is missing required information.");
        return;
      }

      localStorage.setItem("instance", instance);

      try {
        const res = await axios.post(publicOptOutUrl(), { instance, token }, {
          headers: {
            Accept: "application/json",
            instance
          }
        });
        if (!active) return;
        setStatus("success");
        setMessage(res.data?.message || "You have been opted out of CRM email campaigns.");
      } catch (error) {
        if (!active) return;
        setStatus("error");
        setMessage(messageFromError(error));
      }
    };

    optOut();

    return () => {
      active = false;
    };
  }, [email, instance, preview, token]);

  return (
    <Container className="py-5">
      <Card className="mx-auto" style={{ maxWidth: 640 }}>
        <Card.Body>
          <h1 className="h4 mb-3">Email Campaign Opt-Out</h1>
          {status === "loading" ? (
            <div className="d-flex align-items-center">
              <Spinner animation="border" size="sm" className="me-2" />
              <span>{message}</span>
            </div>
          ) : (
            <Alert className="mb-0" variant={status === "success" ? "success" : "danger"}>
              {message}
            </Alert>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default EmailOptOut;
